import { FormattedMessage } from 'react-intl';
import AccordionSection from '../AccordionSection';
import ProfileColorPicker from '../ProfileColorPicker';

const ColorSchemeSection = () => (
  <AccordionSection
    title={<FormattedMessage id="myProfile.colorScheme" defaultMessage="Barevné schéma aplikace" />}
  >
    <ProfileColorPicker />
  </AccordionSection>
);

export default ColorSchemeSection;
